import { DateFormat } from "../Helper";
import Address from "../shared/Address";
import { Col, Row } from "react-bootstrap";
const ClientSummary = ({ invoice, bp, user }) => {
  return (
    <>
      <div className="invoice-title print-reduce-font-size">
        <div className="d-flex justify-content-between">
          <div className="mb-2">
            <h2 className="mb-1 text-muted">{bp.bp_name}</h2>
            <small>{bp.branch.bp_branch_name}</small>
          </div>

          <h4 className="float-end font-size-15">
            Invoice #{invoice.bp_br_bill_num}{" "}
          </h4>
        </div>

        <Row>
          <Col xs={6}>
            <div className="text-muted">
              <Address
                addresses={bp.branch.address_info}
                contacts={bp.branch.contact_info}
              />
            </div>
          </Col>
          <Col xs={6} className="text-end">
            <div className="text-muted">
              <h5 className="font-size-15 mb-2">
                Invoice Date: <DateFormat value={invoice.invoice_date} />
              </h5>
              <h5 className="font-size-15 mb-2">
                Billed To: {`${user.first_name} ${user.last_name}`}
              </h5>
              <Address addresses={user.addresses} contacts={user.contacts} />
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
};
export default ClientSummary;
